import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/srv/sarvban_front/layouts/default.vue").then(m => m.default || m)),
  farm: defineAsyncComponent(() => import("/srv/sarvban_front/layouts/farm.vue").then(m => m.default || m)),
  payment: defineAsyncComponent(() => import("/srv/sarvban_front/layouts/payment.vue").then(m => m.default || m)),
  test: defineAsyncComponent(() => import("/srv/sarvban_front/layouts/test.vue").then(m => m.default || m))
}